var threadRunner = {
    buttonSwitch: false,
	init : function() {
		if (eM.getPageType() == "thread") {
			this.action();
		}
	},
	action : function() {
		var self = this;

		$('.lia-linear-display-message-view').bind('DOMSubtreeModified', function () {
			if(!self.buttonSwitch) {
				self.buttonSwitch = true;
				setTimeout(function () {
					self.switchReplyButtons();
					//self.setRootQrText();
					self.buttonSwitch = false;
			},300);
			}

		});


		var mV = $(".lia-linear-display-message-view");

		//end pagination
		var firstPagingElement = $(".lia-paging-full");
		var pagingWidth = 0;
		var iW = 50;
		var i = this;
		//itemWidth


		//add pagination to top of thread
		var pagingEntity = $('#pager').clone();
		if( pagingEntity )
		{
			pagingEntity.find('.lia-paging-full-left').addClass('no-hide');
		}


		if ($('.lia-panel-message-root').length) {
			//first page
			var fM = $('.first-message');
			// fM.find(".lia-message-view").css("background-color","#fff");
			fM.after(pagingEntity.clone());
			if ($(".lia-linear-display-message-view").length > 1) {
				fM.append('<div class="thread-paging-mask-top"></div>');
			}

		} else {
			$('div.message-list').prepend(pagingEntity.clone());
			$('div.message-list').find(".lia-paging-full-wrapper").css("background", "transparent");
			// mV.css("padding-top","30px");
		}

		var buttons = document.querySelectorAll(".lia-menu-bar-buttons");

		if( buttons.length )
		{
			buttons[0].style.display = "inline";
		}

		//start injecting titles into message button links
		var replyTranslation = $('#reply-hidden-translation').html();
		var quickReplyTranslation = $('#quick-reply-hidden-translation').html();
		$('a.lia-action-reply').attr('title', replyTranslation);
		$('a.lia-action-quick-reply').attr('title', quickReplyTranslation);
		//end title injection

		var mainRight = $('div.lia-panel-message-root .lia-quilt-column-main-right');
		// var msgView = $('.lia-linear-display-message-view');

		var pgWrapper = $('.lia-paging-full-wrapper');
		var adjustBackground = function() {
			var elementsToBeAdjusted = [
				'.lia-linear-display-message-view',
				'#pdc6_prev_next_thread',
				'#pdc6_thread_reply_button'
			];

			for(var i in elementsToBeAdjusted) {
				$(elementsToBeAdjusted[i]).each(function() {
					var $this = $(this);
					if ($this.find('.lia-panel-message-root').length == 0) {
						$this.offset({
							left : 0
						});
						$this.width($(window).width());
					}
				});
			}

			pgWrapper.offset({
				left : 0
			}).width($(window).width());

		};

		//top cutouts
		var cutoutMarkup = '<div class="cutout-left"><div class="inner"></div></div>';
		var pgWrapper = $('.lia-paging-full-wrapper');


		//check length of usernames, and make smaller if over a certain length
		/*
		$('div.username a').each(function() {
			var $this = $(this);

			//check if there is an icon ,and add it's width
			if ($this.parent().find('img').length > 0) {
				var additionalLength = 32;
			} else {
				var additionalLength = 0;
			}

			var fullWidth = additionalLength + $this.width();
			var thisParent = $this.parent();
			if (fullWidth > 150) {
				thisParent.addClass('smaller');
				var pPUserName = thisParent.parent().parent().find('.pdc6-message-author-details-hidden .username');
				//a length cant be measured on hidden elements, so manually inserting into hidden element
				pPUserName.addClass('smaller');
			} else if (fullWidth > 130) {
				//make smaller
				thisParent.addClass('small');
				//pPUserName.addClass('small');
			}
		});
		*/


		if ($('.lia-panel-message-root').length < 1) {
			//we're on second page, so need to position
			//thread options button
			$('div.lia-menu-bar-buttons').css({
				top : ( eM.getUserLocaleCode() == 'ar_AE' || eM.getLocale() == 'ar_AE' ) ? '-77px' : -44,
				left : ( eM.getUserLocaleCode() == 'ar_AE' || eM.getLocale() == 'ar_AE' ) ? 0 : 855
			}).addClass( 'page-gt-1' );

			if( !$( '#PDC6-main-container' ).hasClass( 'thread-compose-page' ) )
			{
				$( 'div.middle-mask').css({
					'background-color' : '#eee'
				} );
			}

			if( $( '#PDC6-main-container' ).hasClass( 'thread-page-1' ) )
			{
				$( '#theHero' ).find( '.right-mask' ).remove();
				$( '#PDC6-main-container' ).removeClass( 'thread-page-1' ).addClass( 'thread-page-2' );
			}

			$( 'body' ).addClass( 'ForumTopicPage2' );

		}
		else
		{
			$( 'body' ).addClass( 'ForumTopicPage1' );
		}

		//update hover state for kudos button
		/*
		var kudosGive = {
			main : $('.lia-button-image-kudos-give')
		};
		kudosGive.main.mouseenter(function() {
			if ($(this).parents('.lia-panel-message-root').length < 1) {
				$(this).parent().find('.lia-button-image-kudos-count').css({
					'background-color' : '#0068bf'
				}).find('span').css({
					color : '#fff'
				});
			}
		});

		kudosGive.main.mouseleave(function() {
			if ($(this).parents('.lia-panel-message-root').length < 1) {
				$(this).parent().find('.lia-button-image-kudos-count').css({
					'background-color' : '#fff'
				}).find('span').css({
					color : '#0068bf'
				});
			}
		});
		*/

		i.adjustQuickReplyButtonsHolderWidth();
		i.handleQuickReply();
		i.setRootQrText();
		i.setThreadReplyLink();
		i.setPrevNextContent();
		i.switchReplyButtons();
		i.updateReplyButtonTitles();
	},
	adjustQuickReplyButtonsHolderWidth : function() {
		var i = this;
		i.haveWidth = false;

		i.w = 0;
		$(".lia-action-quick-reply").click(function() {
			if (!i.haveWidth) {

				setTimeout(function() {
					threadRunner.modifyQrBtnsWidth();
				}, 50);
			}
		});
		//keeping it apart


	},
	modifyQrBtnsWidth: function(w) {
			var i = this;
					//console.log(i);

			var qR = $(".lia-component-quickreply");
			if(i.w==0){
				qR.each(function(x, e) {
					var q = $(e);
					if (!q.hasClass(".lia-js-hidden")) {
						//we have the one!
						q.find(".lia-button-wrapper").each(function(x, e) {

							i.w += $(e).width();
						});
						return;
					}
				});
				i.w += 5; //margin

				i.haveWidth = true;

			}


			qR.find(".lia-button-group").each(function(x, e) {

				$(e).width(i.w);
			});
	},
	handleQuickReply: function(){
		//people may quick reply
		//if they do, Lithium rebuild the page, which is fun for us, yay, fun. (imagine grumpy cat at this point in time)
		$(".lia-quilt-forum-message").find(".lia-button-Submit-action").click(function(){
			setTimeout(function(){
				var t = threadRunner;
				//t.setRootQrText();
				//t.modifyQrBtnsWidth();
				//t.adjustQuickReplyButtonsHolderWidth();

			},5000); // going to be really complicated detecting the change, so being a bit dumb right now

		});
	},
	setRootQrText: function(){
		var q = $('.lia-panel-message-root').find('.lia-action-quick-reply');
		if (q.length > 0) {
			var qText = q.html();
			qText = qText.replace(" ", "<br />");
			q.html(qText);
		}
	},

	setThreadReplyLink: function () {
		//get thread reply link from root message
		var threadReplyLink = $('.reply-action-link').eq(0).attr('href');

		//set link
		if(threadReplyLink !== undefined) {
			$('#pdc6_thread_reply_button a').attr('href',threadReplyLink);
		} else {
			$('#pdc6_thread_reply_button').hide();
		}

	},

	setPrevNextContent: function () {
		//get links
		var prevLink = $('#threadnavigator_0 .lia-component-previous .lia-link-navigation');
		var nextLink = $('#threadnavigator_0 .lia-component-next .lia-link-navigation');
		var prevHref = prevLink.attr('href');
		var prevTitle = prevLink.attr('title');
		var nextHref = nextLink.attr('href');
		var nextTitle = nextLink.attr('title');

		//set links
		if(prevHref !== undefined) {
			$('#pdc6_prev_next_thread .previous').attr('href',prevHref);
			$('#pdc6_prev_next_thread .previous .text .title').html(prevTitle);
		} else {
			$('#pdc6_prev_next_thread .previous').hide();
		}

		if(nextHref !== undefined) {
			$('#pdc6_prev_next_thread .next').attr('href',nextHref);
			$('#pdc6_prev_next_thread .next .text .title').html(nextTitle);
		} else {
			$('#pdc6_prev_next_thread .next').hide();
		}

	},

	switchReplyButtons: function () {
		//console.log('switching reply buttons');
		$('.lia-linear-display-message-view').each(function () {
			var thisElement = $(this);
		    thisElement.find('.lia-action-quick-reply').before(thisElement.find('.lia-action-reply')[0]);
		    //cheeky quick fix to turn on quote button if reply buttons are present
		    //todo: refactor into freemarker if possible
		    //console.log('length: ' + (thisElement.find('.lia-action-quick-reply').length) > 0 );
		    if(thisElement.find('.lia-action-quick-reply').length > 0) {
		    	thisElement.find('.quote-link').show();

		    } else {
		    	//if there isn't a reply button either, remove margin left
		    	//console.log('LOTS OF LENGTH PLZ: ' + thisElement.find('.lia-action-reply').length);
		    	if(thisElement.find('.lia-action-reply').length < 1) {
		    		thisElement.find('.MessagesPositionInThread').css('margin-left','0px');
		    	}
		    }
		});
	},

	updateReplyButtonTitles: function () {

		var html1 = $('a.lia-action-reply').html()
		  , html2 = $('a.lia-action-quick-reply').html();

		if( html1 )
		{
			$('a.lia-action-reply').attr('title', html1.replace(/(<([^>]+)>)/ig," ") );
		}

		if( html2 )
		{
			$('a.lia-action-quick-reply').attr('title', html2.replace(/(<([^>]+)>)/ig," ") );
		}
	}
};
